// extracted by mini-css-extract-plugin
module.exports = {"main_page":"FearAndGreed_main_page__3nN4j","main_header":"FearAndGreed_main_header__CTfWF","content":"FearAndGreed_content__2KEqO"};